import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { environment, RoleService } from '@perval/shared';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(private roleService: RoleService) {}

  canActivate(next: ActivatedRouteSnapshot): boolean {
    const expectedRole = next.data['expectedRole'];
    for (const role of this.roleService.currentUserRoles) {
      if (expectedRole.includes(role)) {
        return true;
      }
    }

    window.location.href = `${environment.host}/content/accueil`;
    return false;
  }
}
